import MestrosScreen from "../../Screen/ERP/Desarrollo/MaestrosScreen";

export const Desarrollo = [
  {
    path: "Desarrollo/Maestros",
    permiso: 82,
    element: <MestrosScreen />,
  },

];
  
export default Desarrollo;
  